'use es6';

export const InboundDbListSeg = 'InboundDbListSeg';
export const ListSegClassic = 'ListSegClassic';
export const ContactSearch = 'ContactSearch';
export const CrmSearch = 'CrmSearch';